import * as t from '../types';
import {GET_GRADES_SUCCESS, GET_GRADES_FAILED, GET_GRADES_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function getGradesReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_GRADES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_GRADES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_GRADES_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
